import { LuChevronLeft, LuChevronRight } from "react-icons/lu";
import { CustomMenuItem } from "./CustomMenuItem";
import { CustomPaginationSelect } from "./CustomPaginationSelect";
import styles from "../styles/dashboard.module.css";

const DEFAULT_PAGE_SIZES = [10, 20, 50, 100];
const WINDOW = 5;

// Up to WINDOW page numbers around the current page; "..." when more follow
const getPageNumbers = (page, totalPages) => {
  const start = Math.max(1, Math.min(page - 2, totalPages - WINDOW + 1));
  const end = Math.min(totalPages, start + WINDOW - 1);
  return {
    numbers: Array.from({ length: end - start + 1 }, (_, i) => start + i),
    more: end < totalPages,
  };
};

// "Show [10] Showing 1-10 from 100" + page buttons - shared by every table
const TablePagination = ({ page, limit, total, onPageChange, onLimitChange, pageSizes = DEFAULT_PAGE_SIZES, hideSize = false }) => {
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const { numbers, more } = getPageNumbers(page, totalPages);
  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to = Math.min(page * limit, total);

  return (
    <div className={styles.tableFooter}>
      <div className={styles.footerLeft}>
        {!hideSize && (
          <>
            <span>Show</span>
            <CustomPaginationSelect
              value={limit}
              onChange={(event) => onLimitChange(event.target.value)}
              sx={{ height: "28px !important", fontSize: "12px" }}
            >
              {pageSizes.map((size) => (
                <CustomMenuItem key={size} value={size}>
                  {size}
                </CustomMenuItem>
              ))}
            </CustomPaginationSelect>
          </>
        )}
        <span>
          Showing {from}-{to} from {total}
        </span>
      </div>

      <div className={styles.pagination}>
        <button
          type="button"
          className={styles.pageBtn}
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          <LuChevronLeft />
        </button>
        {numbers.map((number) => (
          <button
            key={number}
            type="button"
            className={`${styles.pageBtn} ${number === page ? styles.pageBtnActive : ""}`}
            onClick={() => onPageChange(number)}
          >
            {number}
          </button>
        ))}
        {more && <span className={styles.pageEllipsis}>...</span>}
        <button
          type="button"
          className={styles.pageBtn}
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          <LuChevronRight />
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
